import React from "react";

import { GridItem } from "commons/ui/Grid";

import FiltersContainer from "components/ui/FiltersContainer";
import SearchInput from "components/ui/SearchInput";

import { TemplateListHook } from "hooks/list/useTemplateList";

function TemplatesTableFilters({ templatesListHook }: { templatesListHook: TemplateListHook }) {
    const { onSearchFilterChange, filterSearchHook } = templatesListHook;

    const { applyFilters, clearFilters, form } = filterSearchHook;

    return (
        <FiltersContainer applyFilters={applyFilters} clearFilters={clearFilters}>
            <GridItem className={"col-xs-12-4"}>
                <SearchInput
                    placeholder={"Cerca"}
                    value={form.search.name}
                    onChange={onSearchFilterChange}
                    filterInput
                />
            </GridItem>
        </FiltersContainer>
    );
}

export default TemplatesTableFilters;
